export const SLUG_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/;
export const VERIFICATION_CODE_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9_-]*$/;

export const DESCRIPTION_MIN_LENGTH = 3;
export const DESCRIPTION_MAX_LENGTH = 500;
export const VERIFICATION_CODE_MIN_LENGTH = 4;
export const VERIFICATION_CODE_MAX_LENGTH = 64;
export const IMPORT_MAX_FILE_BYTES = 5 * 1024 * 1024;
export const IMPORT_ALLOWED_EXTENSIONS = ['.csv', '.xls', '.xlsx'];

export const validateSlug = (slug) => {
  const value = (slug || '').trim();

  if (!value) {
    return 'Slug wajib diisi.';
  }

  if (!SLUG_PATTERN.test(value)) {
    return 'Slug hanya huruf, angka, hyphen, atau underscore, dan harus diawali huruf/angka.';
  }

  return '';
};

export const validateDescription = (description) => {
  const value = (description || '').trim();

  if (!value) {
    return 'Deskripsi wajib diisi.';
  }

  if (value.length < DESCRIPTION_MIN_LENGTH) {
    return `Deskripsi minimal ${DESCRIPTION_MIN_LENGTH} karakter.`;
  }

  if (value.length > DESCRIPTION_MAX_LENGTH) {
    return `Deskripsi maksimal ${DESCRIPTION_MAX_LENGTH} karakter.`;
  }

  return '';
};

export const validateVerificationCode = (verificationCode) => {
  const value = (verificationCode || '').trim();

  if (!value) {
    return '';
  }

  if (value.length < VERIFICATION_CODE_MIN_LENGTH) {
    return `Kode verifikasi minimal ${VERIFICATION_CODE_MIN_LENGTH} karakter.`;
  }

  if (value.length > VERIFICATION_CODE_MAX_LENGTH) {
    return `Kode verifikasi maksimal ${VERIFICATION_CODE_MAX_LENGTH} karakter.`;
  }

  if (!VERIFICATION_CODE_PATTERN.test(value)) {
    return 'Kode verifikasi hanya huruf, angka, hyphen, atau underscore, dan harus diawali huruf/angka.';
  }

  return '';
};

export const validateCreateForm = ({ slug, description, verificationCode }) => {
  const errors = {};
  const slugError = validateSlug(slug);
  const descriptionError = validateDescription(description);
  const verificationCodeError = validateVerificationCode(verificationCode);

  if (slugError) errors.slug = slugError;
  if (descriptionError) errors.description = descriptionError;
  if (verificationCodeError) errors.verificationCode = verificationCodeError;

  return errors;
};

export const validateEditForm = ({ description, verificationCode }) => {
  const errors = {};
  const descriptionError = validateDescription(description);
  const verificationCodeError = validateVerificationCode(verificationCode);

  if (descriptionError) errors.description = descriptionError;
  if (verificationCodeError) errors.verificationCode = verificationCodeError;

  return errors;
};

export const validateImportFile = (file) => {
  const errors = {};

  if (!file) {
    errors.file = 'File wajib dipilih.';
    return errors;
  }

  if (file.size === 0) {
    errors.file = 'File tidak boleh kosong.';
    return errors;
  }

  const name = (file.name || '').toLowerCase();
  const ext = name.includes('.') ? name.slice(name.lastIndexOf('.')) : '';

  if (!IMPORT_ALLOWED_EXTENSIONS.includes(ext)) {
    errors.file = 'Format file harus CSV, XLS, atau XLSX.';
    return errors;
  }

  if (file.size > IMPORT_MAX_FILE_BYTES) {
    errors.file = 'Ukuran file maksimal 5 MB.';
  }

  return errors;
};

export const hasValidationErrors = (errors) => Object.keys(errors).length > 0;
